<template>
	<div class="modal fade show d-block" tabIndex="-1" role="dialog">
		<div class="modal-bg"></div>
		<div v-if="mode === 'form'" class="modal-dialog modal-dialog-scrollable" role="document">
			<form class="modal-content" v-on:submit.prevent="submit">
				<div class="modal-header text-dark">
          <h5 class="modal-title">CONTACT SCOUTRED</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left text-dark">
					<div v-if="token === null" class="mb-2">
						<inputText :blur="validateEmail" :error="error && error.email" v-model="email" placeholder="Email"/>
					</div>
					<div class="mb-2">
						<inputSelect :change="validateSubject" :error="error && error.subject" :options="subjectOptions" v-model="subject" 
							placeholder="Select a subject"/>
					</div>
					<div class="mb-2" :blur="validateOther" v-if="subject == 'Other'">
						<inputText :error="error && error.other" v-model="other" placeholder="Other subject"/>
					</div>
					<div>
						<inputTextarea :blur="validateBody" :error="error && error.body" v-model="body" placeholder="Message"/>
					</div>
          
        </div>  
        <div class="modal-footer">
          <loadButton :isLoading="loading" :isSubmit="true" buttonClass="btn btn-dark">Submit</loadButton>
        </div>
			</form>
		</div>
		<div v-else-if="mode === 'sent'" class="modal-dialog modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header text-dark">
	        <h5 class="modal-title">MESSAGE SENT</h5>
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="close">
	          <span aria-hidden="true">&times;</span>
	        </button>
	      </div>
	      <div class="modal-body text-left text-dark">
					<p class="mb-0">
						Your message has been sent to Scoutred. We'll be in touch shortly.
					</p>
        </div>  
        <div class="modal-footer">
          <button v-on:click="close" class="btn btn-dark">Done</button>
        </div>
      </div>	
		</div>
	</div>
</template>

<script>

import inputSelect from '../form/input-select';
import inputText from '../form/input-text';
import inputTextarea from '../form/input-textarea';
import loadButton from '../form/load-button';
import validate from '../../utility/validate'

export default {
	name:'message-modal',
	props: {
		close: Function,
	},
	components:{
		inputSelect,
		inputText,
		inputTextarea,
		loadButton,
	},
	computed:{
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	data:function(){
		return {
			email:'',
			error:null,
			loading:false,
			validationError: null,
			body:'',
			mode:'form',
			other:'',
			subject:'',
			subjectOptions:[
				'I\'m having a problem',
				'I\'m interested in a custom search',
				'Other',
			]
		};
	},
	methods:{

		clearError: function(key){
			if (key){
				if (!this.error || !this.error[key]) return

				// immutably remove key from obj
				// https://stackoverflow.com/questions/34401098/remove-a-property-in-an-object-immutably
				const { [key]: value, ...error } = this.error;
				this.error = error
				return
			}
			this.error = null
		},

		validateEmail: function(){
			let err;

			if (this.token){
				err = null
			} else if (!this.email){
				err = 'enter an email';
			} else if (!validate.strPattern({str:this.email, pattern:'email'})){
				err = 'invalid email entered';
			}

			if (err){
				this.error = this.error? {...this.error, email: err}: {email: err}
				return false
			}
			this.clearError('email')
			return true
		},

		validateBody: function(){
			let err;
			if (!this.body){
				err = 'enter a message body';
			} else if (this.body.length <= 2){
				err = 'body must be at least 2 characters';
			} else if (this.body.length > 200000){
				err = 'body is too long (max 200,000 characters)';
			}

			if (err){
				this.error = this.error? {...this.error, body: err}: {body: err}
				return false
			}
			this.clearError('body')
			return true
		},

		validateSubject: function(){
			let err;

			if (!this.subject){
				err = 'select a subject';
			} else if (this.subject.length <= 2){
				err = 'subject must be at least 2 characters';
			} else if (this.subject.length > 2000){
				err = 'subject is too long (max 2,000 characters)';
			}

			if (err){
				this.error = this.error? {...this.error, subject: err}: {subject: err}
				return false
			}
			this.clearError('subject')
			return true
		},

		validateOther: function(){
			let err;
			if (this.other.length > 2000){
				err = 'other is too long (max 2,000 characters)';
			}

			if (err){
				this.error = this.error? {...this.error, other: err}: {other: err}
				return false
			}
			this.clearError('other')
			return true
		},

		// validate input checks all fields to ensure they have 
		// allowed values, returns true if valid, false otherwise
		validateInput: function(){
			this.clearError()
			
			this.validateEmail();
			this.validateBody();
			this.validateSubject();

			// if there is an error, return false (not validated)
			if (this.error && Object.keys(this.error).length > 0){
				return false;
			}
			return true;
		},

		// submit will validate the form, and if successful, will form
		// and submit a contact request
		submit: function(){
			if (this.loading) return;
			if (!this.validateInput()) return;
			
			this.loading = true;

			this.$store.dispatch('MESSAGE_SEND', {
				body: this.body,
				email: this.email,
				currentUrl: window.location.href,
				subject: this.subject === 'Other'? this.other: this.subject
			}).then(()=>{
				this.mode = 'sent'
				this.loading = false;
			}).catch((e)=>{
				this.loading = false;
			});
		}
	}
};

</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/message/message-modal.vue